import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import msg from '@salesforce/retail-react-app/app/components/display-price/messages';
import {Text, VisuallyHidden} from '@salesforce/retail-react-app/app/components/shared/ui';
import {normalizeMyrCurrencyDisplay} from '@amblique/king-living/app/utils/format-currency-hide-zero-cents';

/**
 * @override Remove MYR symbol/amount space for en-MY parity with live SFCC (KINDW-658).
 */
const CurrentPrice = ({labelForA11y, price, as, isRange = false, currency, ...extraProps}) => {
  const intl = useIntl();
  const currentPriceText = normalizeMyrCurrencyDisplay(
    intl.formatNumber(price, {
      style: 'currency',
      currency,
    }),
    currency
  );

  return (
    <>
      {isRange ? (
        <Text
          as={as}
          {...extraProps}
          aria-live="polite"
          aria-label={intl.formatMessage(msg.ariaLabelCurrentPriceWithRange, {
            currentPrice: currentPriceText,
          })}
        >
          {intl.formatMessage(msg.currentPriceWithRange, {
            currentPrice: currentPriceText,
          })}
        </Text>
      ) : (
        <Text
          as={as}
          {...extraProps}
          aria-label={intl.formatMessage(msg.ariaLabelCurrentPrice, {
            currentPrice: currentPriceText,
          })}
        >
          {currentPriceText}
        </Text>
      )}
      <VisuallyHidden aria-atomic={true} aria-live="polite">
        {labelForA11y}
        {isRange ?
          intl.formatMessage(msg.ariaLabelCurrentPriceWithRange, {
            currentPrice: currentPriceText,
          }) :
          intl.formatMessage(msg.ariaLabelCurrentPrice, {
            currentPrice: currentPriceText,
          })}
      </VisuallyHidden>
    </>
  );
};

CurrentPrice.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  labelForA11y: PropTypes.string,
  as: PropTypes.string,
  isRange: PropTypes.bool,
  extraProps: PropTypes.object,
};

export default CurrentPrice;
